import Axios from 'axios';
import { getNotificationApiBase } from './notificationBase';
import {
    mapBlastSearchSortParams,
    mapMembersToReceivers,
    resolveBlastTypeParam,
} from './blastHelpers';

export const searchBlastApi = ({
    authToken,
    deviceId,
    sortBy,
    sort,
    search,
    page,
    pageSize,
    messageType,
}) => {
    if (authToken != null) {
        const { sortBy: resolvedSortBy, sortDirection } = mapBlastSearchSortParams({
            sortBy,
            sort,
        });
        const params = {
            subject: search || '',
            page: page != null ? page : 0,
            pageSize: pageSize != null && Number(pageSize) > 0 ? Number(pageSize) : 10,
            sortBy: resolvedSortBy,
            sortDirection,
        };
        const blastType = resolveBlastTypeParam(messageType);
        if (blastType) {
            params.type = blastType;
        }
        return Axios({
            method: 'get',
            url: getNotificationApiBase() + 'v2/message-blasts',
            params,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const viewBlastDetailApi = ({ authToken, deviceId, id }) => {
    if (authToken != null && id != null) {
        return Axios({
            method: 'get',
            url: getNotificationApiBase() + 'v2/message-blasts/' + id,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const viewBlastReceiversApi = ({
    authToken,
    deviceId,
    id,
    page,
    pageSize,
    name,
    receiver,
}) => {
    if (authToken != null && id != null) {
        return Axios({
            method: 'get',
            url: getNotificationApiBase() + 'v2/message-blasts/' + id + '/receivers',
            params: {
                name: name || '',
                receiver: receiver || '',
                page: page != null ? page : 0,
                pageSize: pageSize != null ? Math.min(pageSize, 500) : 500,
            },
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const updateBlastApi = ({ authToken, deviceId, id, data }) => {
    if (authToken != null && id != null) {
        return Axios({
            method: 'put',
            url: getNotificationApiBase() + 'v2/message-blasts/' + id,
            data: {
                subject: data.subject,
                sendDate: data.sendDate,
                content: data.content,
            },
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const createBlastApi = ({ authToken, deviceId, data }) => {
    if (authToken != null) {
        const type =
            data.messageType === 1 || data.messageType === '1' ? 'EMAIL' : 'SMS';
        return Axios({
            method: 'post',
            url: getNotificationApiBase() + 'v2/message-blasts',
            data: {
                type,
                subject: data.subject,
                sendDate: data.sendDate,
                content: data.content,
                receivers: mapMembersToReceivers(data.members, data.messageType),
            },
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const deleteBlastApi = ({ authToken, deviceId, id }) => {
    if (authToken != null && id != null) {
        return Axios({
            method: 'delete',
            url: getNotificationApiBase() + 'v2/message-blasts/' + id,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

/** @deprecated Use viewBlastDetailApi + viewBlastReceiversApi */
export const viewBlastApi = viewBlastDetailApi;
